<template>
  <div class="newzone" :class="{ inApp: $root.$data.isApp }">
    <div class="newzoneBox">
      <common-title titleName="新人专区" :bcColor="'#fefeff00'" :zIndex="1000" :goHome="true" />
    </div>
    <!-- 优惠券 -->
    <div class="couponBox" v-if="couponList">
      <div class="couponTit">
        <img
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/newzhuce/%E7%A6%8F%E5%88%A9%E4%B8%80%402x.png"
          alt=""
        />
        <h2>福利{{ getChineseNumber(welfare.find(item => item.type === 'coupon')?.index) }}</h2>
        <span>|</span>
        <p>*领取后，前往APP-我的-优惠券使用</p>
      </div>

      <div class="couponList" v-for="(item, index) in couponList" :key="index">
        <span class="tips">新用户专享</span>
        <div class="couponItem">
          <div class="couponInfo">
            <h3>
              {{ item.discountAmount }}<span>{{ item.discountType === 2 ? '折' : '元' }}</span>
            </h3>
            <p>满{{ item.usableCondition }}可用</p>
          </div>
          <div class="couponTime">
            <h2>{{ item.couponName }}</h2>
            <p>{{ showType(item.productionFitType, item.packageFitType) }}</p>
            <span
              >{{ timeFormat(item.receiveTimeBegin) }}-{{ timeFormat(item.receiveTimeEnd) }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 课程 -->
    <div class="courseBox" v-if="courseInfo">
      <div class="courseTit">
        <img
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/newzhuce/%E7%A6%8F%E5%88%A9%E4%BA%8C%402x.png"
          alt=""
        />
        <h2>福利{{ getChineseNumber(welfare.find(item => item.type === 'course')?.index) }}</h2>
        <span>|</span>
        <p>*领取后，前往APP-学习页面查看课程</p>
      </div>
      <img
        class="courseBg"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/newzhuce/coursebg.png"
        alt=""
      />
      <div class="joinCount">{{ getCourseCount }}人报名</div>
    </div>
    <!-- 会员 -->
    <div class="memberBox" v-if="memberPackage">
      <div class="memberTit">
        <img
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/newzhuce/%E7%A6%8F%E5%88%A9%E4%B8%89%402x.png"
          alt=""
        />
        <h2>福利{{ getChineseNumber(welfare.find(item => item.type === 'member')?.index)}}</h2>
        <span>|</span>
        <p>*领取后，前往APP-我的-会员中心查看</p>
      </div>
      <div class="memberInfo">
        <p>{{ memberPackage[0]?.name || '' }}</p>
      </div>
    </div>
    <!-- 吸底 -->
    <div class="startStudy">
      <p v-if="courseInfo">
        已有<i>{{ getCourseCount }}</i
        >人领取
      </p>
      <span :class="{ superflu: !courseInfo }" @click="goHome">一键领取，开启学习之旅</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import CommonTitle from '@/components/header/CommonTitle.vue';
import { reqNewzoneGift, reqCouponList } from '@/api/newUser';
import { reqCombinationlist } from '@/api/combination';
import { reqProducts } from '@/api/home';

export default {
  components: {
    CommonTitle,
  },
  data() {
    return {
      courseInfo: null,
      couponList: null,
      getCourseCount: 0,
      memberPackage: null,
    };
  },

  computed: {
    loading() {
      let load = true;
      if (this.couponList || this.courseInfo) {
        load = false;
      }
      return load;
    },
    // 根据实际存在的福利项动态生成对应的序号
      welfare() {
        const welfareItems = [];
        let count = 1;
        
        // 按照固定顺序（优惠券、课程、会员）为存在的项分配序号
        if (this.couponList) {
          welfareItems.push({ type: 'coupon', index: count++ });
        }
        if (this.courseInfo) {
          welfareItems.push({ type: 'course', index: count++ });
        }
        if (this.memberPackage) {
          welfareItems.push({ type: 'member', index: count++ });
        }
        
        return welfareItems;
      },
    ...mapState(['userInfo']),
  },
  created() {
    this.getGitList();
  },
  mounted() {},

  methods: {
      getChineseNumber(num) {
        const map = { 1: '一', 2: '二', 3: '三' };
        return map[num] || '';
      },
      async getGitList() {
      const res = await reqNewzoneGift();
      if (res?.code === 0) {
        const list = res?.data;
        const courseIds = [];
        const allPackageIds = [];
        const couponIds = [];
        // eslint-disable-next-line no-unused-expressions
        list?.map((item) => {
          if (item.type === 1) {
            courseIds.push(item.productId);
          }
          if (item.type === 2) {
            couponIds.push(item.couponId);
          }
          if (item.type === 3) {
            allPackageIds.push(item.memberPackageId);
          }
        });

        this.getCouponDetail(couponIds);
        this.getCourseInfo(courseIds);
        this.getPackageInfo(allPackageIds);
      }
    },

    // 根据优惠券id集合 查询优惠券信息
    async getCouponDetail(couponIds) {
      if (!couponIds.length) return;
      const ids = `couponId=${couponIds?.map((item) => item).join('&couponId=')}`;
      const { code, data } = await reqCouponList(ids);
      if (code === 0 && data) {
        this.couponList = data;
      }
    },
    // 课程信息
    async getCourseInfo(courseIds) {
      if (!courseIds.length) return;
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const res = await reqProducts(courseIds, endPoint);
      if (res?.code === 0 && res?.data) {
        this.courseInfo = res.data;
        // 计算所有课程的 initialSales + realSales 总和
        this.getCourseCount = res.data.reduce((total, course) => {
          return total + (course.initialSales || 0) + (course.realSales || 0);
        }, 0);
      }
    },
    // 套餐会员
    async getPackageInfo(packageIds) {
      if (!packageIds.length) return;
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const res = await reqCombinationlist(0, endPoint, packageIds);
      if (res?.code === 0 && res?.data) {
        this.memberPackage = res.data;
      }
    },
    showType(type, status) {
      const typeMap = {
        1: '所有产品',
        2: '指定产品可用',
        3: '指定产品可用',
      };
      let text = typeMap[type] || '';
      if (status === 4) {
        text = type === 1 ? '所有产品' : '指定产品可用';
      } else if (status === 5) {
        text = '指定产品可用';
      }
      return text;
    },
    timeFormat(time) {
      return time.split(' ')[0];
    },

    goHome() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('goToHomePage');
        return;
      }
      window.location.href = '/ark/exam26?code=12';
    },
  },
};
</script>

<style lang="scss" scoped>
// ::v-deep .couponGet {
//   display: none;
// }
.newzone {
  width: 100%;
  min-height: 100vh;
  // padding-top: 100px;
  padding-bottom: 218px;
  background-color: #ffecb3;
  .newzoneBox {
    width: 100%;
    height: 482px;
    margin: 0 auto;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/newzhuce/%E8%83%8C%E6%99%AF.png')
      no-repeat center center;
    background-size: 100% 100%;
  }
  .couponBox {
    width: 678px;
    margin: 0 auto;
    padding: 20px;
    background: #fff;
    border-radius: 18px;
    .couponTit {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      img {
        display: block;
        width: 43px;
        height: 43px;
      }
      h2 {
        margin-right: 10px;
        color: #111;
        font-weight: 600;
        font-size: 29px;
      }
      span {
        margin-right: 10px;
        color: #999;
        font-size: 30px;
      }
      p {
        padding-top: 3px;
        color: #999;
        font-weight: 400;
        font-size: 22px;
      }
    }
    .couponList {
      position: relative;
      width: 100%;
      height: 192px;
      margin-top: 20px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/newzhuce/youhuiquan.png')
        no-repeat center center;
      background-size: 100% 100%;
      .tips {
        position: absolute;
        top: 0;
        left: 0;
        width: 110px;
        height: 33px;
        color: #fff;
        font-weight: 500;
        font-size: 17px;
        line-height: 35px;
        text-align: center;
        background: linear-gradient(90deg, #fb6972 0%, #ff4846 100%);
        border-radius: 18px 0 18px 0;
      }
      .couponItem {
        display: flex;
        align-items: center;
        height: 100%;
        // margin:0 30px;
        .couponInfo {
          width: 180px;
          // background: #ff7f41;
          margin-right: 30px;
          h3 {
            color: #ff3938;
            font-weight: normal;
            font-size: 43px;
            text-align: center;
            span {
              color: #ff3938;
              font-weight: 600;
              font-size: 25px;
            }
          }
          p {
            margin-top: 8px;
            color: #83623d;
            font-weight: 400;
            font-size: 22px;
            text-align: center;
          }
        }
        .couponTime {
          width: 400px;
          // background: #999999;
          h2 {
            display: -webkit-box;
            margin-bottom: 20px;
            overflow: hidden;
            color: #333;
            font-weight: 500;
            font-size: 25px;
            line-height: 33px;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          p {
            display: block;
            margin-bottom: 20px;
            color: #83623d;
            font-weight: 400;
            font-size: 22px;
          }
          span {
            display: block;
            color: #83623d;
            font-weight: 400;
            font-size: 22px;
          }
        }
      }
    }
  }
  .courseBox {
    position: relative;
    width: 678px;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    border-radius: 18px;
    .courseTit {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      img {
        display: block;
        width: 43px;
        height: 43px;
      }
      h2 {
        margin-right: 10px;
        color: #111;
        font-weight: 600;
        font-size: 29px;
      }
      span {
        margin-right: 10px;
        color: #999;
        font-size: 30px;
      }
      p {
        padding-top: 3px;
        color: #999;
        font-weight: 400;
        font-size: 22px;
      }
    }
    .courseBg {
      display: block;
      height: 220px;
      margin: 0 auto;
    }
    .joinCount {
      position: absolute;
      bottom: 80px;
      left: 60px;
      color: #333;
      font-weight: 400;
      font-size: 22px;
    }
  }
  .memberBox {
    width: 678px;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    border-radius: 18px;
    .memberTit {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      img {
        display: block;
        width: 43px;
        height: 43px;
      }
      h2 {
        margin-right: 10px;
        color: #111;
        font-weight: 600;
        font-size: 29px;
      }
      span {
        margin-right: 10px;
        color: #999;
        font-size: 30px;
      }
      p {
        padding-top: 3px;
        color: #999;
        font-weight: 400;
        font-size: 22px;
      }
    }
    .memberInfo {
      position: relative;
      width: 100%;
      height: 366px;
      margin: 0 atuo;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/newzhuce/huiyuanbg.png')
        no-repeat center center;
      background-size: 100% 100%;
      p {
        position: absolute;
        // background: #333333;
        top: 30px;
        left: 84px;
        width: 530px;
        overflow: hidden;
        color: #60371c;
        font-weight: 600;
        font-size: 33px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .startStudy {
    position: fixed;
    bottom: 0;
    z-index: 110;
    width: 100%;
    height: 217px;
    padding-top: 1px;
    background: #fff;
    p {
      margin: 20px 0;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      text-align: center;
      i {
        display: inline-block;
        color: #ff7f41;
        font-style: normal;
      }
    }

    span {
      display: block;
      width: 636px;
      height: 82px;
      margin: 0 auto;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 82px;
      text-align: center;
      background: #ff7f41;
      border-radius: 45px;
    }
    .superflu {
      margin-top: 60px;
    }
  }
}

.inApp {
  padding-top: 0;
}
//  ::v-deep .couponGet {
//         display: none;
//       }
</style>
